
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temperature-excursion",
      function () {
        return require("private-next-pages/temperature-excursion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temperature-excursion"])
      });
    }
  